// screens/RestaurantMenu.tsx
import React, { useEffect, useState } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  Alert,
  Platform,
} from "react-native";
import { RouteProp, useNavigation } from "@react-navigation/native";
import { NavigationProps, RootStackParamList } from "../types/navigation";
import MenuScreen from "../components/shared/screens/MenuScreen";
import { MenuItemType } from "../components/shared/types/restaurant.types";
import { FlickOColors } from "../components/shared/styles/color";
import { getResponsiveSize } from "../components/shared/styles/globalStyles";
import { menuScreenStyles } from "../components/shared/styles/styles";
import { restaurantService } from "../services/restaurant.service";
import LoadingSpinnerTrans from "../components/shared/LoadingSpinner";
import { RestaurantMenu as RestMenuType } from "../components/shared/types/restaurant.types";
import { registerPWA } from "../pwa/pwaUtils";

interface CartItem extends MenuItemType {
  quantity: number;
}

interface RestaurantMenuScreenProps {
  route: RouteProp<RootStackParamList, "RestaurantMenu">;
}

export const RestaurantMenu = ({ route }: RestaurantMenuScreenProps) => {
  const navigation = useNavigation<NavigationProps>();
  const { id, updatedAt, onEditPress } = route.params;
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [restData, setRestData] = useState<RestMenuType | null>(null);

  const canRegisterPwa = async () => {
      await registerPWA({
        restaurantId: id,
        scope: "/",
      });
    
  };

  useEffect(() => {
    const fetchRestaurantData = async () => {
      try {
        console.log(
          "fetchRestaurantData called, updatedAt: ",
          updatedAt,
          ", id: ",
          id
        );
        setIsLoading(true);
        const data = await restaurantService.getRestById(id, updatedAt);

        if (!data) {
          Alert.alert("Error", "Restaurant not found");
          return;
        }

        setRestData(data);
        console.log("fetchRestaurantData data", JSON.stringify(data));
      } catch (error) {
        Alert.alert("Error", "Failed to fetch restaurant data");
      } finally {
        setIsLoading(false);
        canRegisterPwa();
      }
    };

    fetchRestaurantData();
  }, [id, updatedAt]);

  const handleAddToCart = (item: MenuItemType, quantity: number) => {
    setCartItems((prev) => {
      const existingItem = prev.find((i) => i.id === item.id);
      if (existingItem) {
        return quantity === 0
          ? prev.filter((i) => i.id !== item.id)
          : prev.map((i) => (i.id === item.id ? { ...i, quantity } : i));
      }
      return [...prev, { ...item, quantity }];
    });
  };

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const totalAmount = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const ViewCartButton = () =>
    cartItems.length > 0 && (
      <TouchableOpacity
        style={styles.viewCartButton}
        onPress={() => {
          console.log("View Cart  called");
          navigation.navigate("CartScreen", {
            cartItems,
          });
        }}
      >
        <Text style={styles.viewCartText}>
          View Cart ({totalItems} items) • ₹{totalAmount}
        </Text>
      </TouchableOpacity>
    );

  return (
    <View style={menuScreenStyles.container}>
      {isLoading && <LoadingSpinnerTrans />}
      <MenuScreen
        restData={restData}
        loading={false}
        onEditPress={onEditPress}
        onAddToCart={handleAddToCart}
      />
      <View style={menuScreenStyles.borderTop}>
        <ViewCartButton />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  viewCartButton: {
    backgroundColor: FlickOColors.success,
    padding: getResponsiveSize(16),
    borderRadius: getResponsiveSize(8),
    margin: getResponsiveSize(16),
    alignItems: "center",
  },
  viewCartText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(16),
    fontWeight: "600",
  },
});
